// extracted by mini-css-extract-plugin
export default {"divider":"qTmShNuYp5tDb6s9uZPg"};